import React from 'react';
import Home from '../../pages/Home';

export default function HomeViewContainer({ records, permissions, onNavigate }) {
  return <Home records={records} permissions={permissions} onNavigate={onNavigate} />;
}
